import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getSaleOrders({ commit }, { projectId, params = {} }) {
    return axios.get(`/projects/${projectId}/sale-orders`, { params })
  },
  searchSaleOrders({ commit }, { projectId, params = {} }) {
    return axios.get(`/projects/${projectId}/sale-orders/search`, { params })
  },
  getSaleOrder({ commit }, id) {
    return axios.get(`/sale-orders/${id}`)
  },
  updateSaleOrder({ commit }, data) {
    return axios.put(`/sale-orders/${data.id}`, data)
  },
  updateSaleOrderStatus({ commit }, data) {
    return axios.put(`/sale-orders/${data.id}/change-status`, data)
  },
  revertOrder({ commit }, {id, data}) {
    return axios.post(`/sale-orders/${id}/revert`, data)
  },
  deleteSaleOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/sale-orders/${payload.id}/delete`, payload)
  },
  declineSaleOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/sale-orders/${payload.id}/decline`, payload)
  },
  cancelSaleOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/sale-orders/${payload.id}/cancel`, payload)
  },
  acceptOrder({ commit }, {id, data}) {
    return axios.post(`/sale-orders/${id}/accept`, data)
  },
  allocateOrder({ commit }, {id, data}) {
    return axios.post(`/sale-orders/${id}/allocate`, data)
  },
  deallocateOrder({ commit }, {id, data}) {
    return axios.post(`/sale-orders/${id}/deallocate`, data)
  },
  shipOrder({ commit }, {id, data}) {
    return axios.post(`/sale-orders/${id}/ship`, data)
  },
  updateItemsAdditional({ commit }, {id, data}) {
    return axios.put(`/sale-orders/${id}/items-additional`, data)
  },
  downloadSaleOrder({ commit }, saleOrder) {
    return axios
      .get(`/sale-orders/${saleOrder.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${saleOrder.document_name}.pdf`)
      })
  },
  xeroSyncSaleOrder({ commit }, saleOrder) {
    return axios.post(`/sale-orders/${saleOrder.id}/xero-sync`, {})
  },
  createVariation({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/sale-orders/${payload.id}/create-variation`, payload)
  },
  acceptVariation({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/sale-orders/${data.id}/accept-variation`, payload)
  },
}
